import React from "react";
import { FaLightbulb, FaUserAlt, FaTrashAlt } from "react-icons/fa";

export default function CommentBox(props) {
  const {
    content,
    noteId,
    handleDeleteJavaTip,
    isSessionNote,
    author,
    isRunningSession,
  } = props;

  return (
    <div className="my-3 w-100 border round-box px-3 py-2">
      <div className="text-info d-flex align-items-center font-size-2 mb-2">
        {!isSessionNote && (
          <>
            <FaLightbulb className="d-flex ml-0 mr-2" />
            <span className="mb-0">Java Tip</span>
            <span className="ml-auto mr-0" />
          </>
        )}
        {isSessionNote && (
          <div className="d-flex justify-content-between w-100 align-items-center">
            <div>
              <FaUserAlt className="mr-2" />
              <span className="mb-0">
                {author && author.firstName + " " + author.lastName}
              </span>
            </div>

            {isRunningSession === false && (
              <div>
                <button
                  onClick={e => handleDeleteJavaTip(e, noteId)}
                  className="border-0 text-danger"
                  style={{ background: "white" }}
                >
                  <FaTrashAlt />
                </button>
              </div>
            )}
          </div>
        )}
      </div>
      <div>
        <p className="card-text">{content && content}</p>
      </div>
    </div>
  );
}
